import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=168ff0a2&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=168ff0a2&prod&lang=css"
import style1 from "./MenuAdmin.vue?vue&type=style&index=1&id=168ff0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168ff0a2",
  null
  
)

export default component.exports